import React from 'react';
import gettext from '@eb/gettext';

import { Button } from '@eb/eds-button';

const ForgotPasswordLink = ({
    handleForgotPassword,
    dataAutomation = 'forgot-password-link',
    isDisabled,
}) => (
    <div
        className="eds-text-bm eds-text-weight--heavy"
        data-automation={dataAutomation}
    >
        <Button
            type="button"
            style="anchor"
            onClick={handleForgotPassword}
            disabled={isDisabled}
            data-automation="signin-forgot-password-button"
        >
            {gettext('Forgot password?')}
        </Button>
    </div>
);

export default ForgotPasswordLink;
